import { render, staticRenderFns } from "./AttractionRow.vue?vue&type=template&id=6f4995a0"
import script from "./AttractionRow.vue?vue&type=script&lang=js"
export * from "./AttractionRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports